import { PaginationQueryObject, QueryConfig } from "./Queries";
import { SPMetadata } from "../../routeComponents/SPMetadata/SPMetadata";

export const ssoOutgoingListQuery = (
  filter: any,
  pagination: PaginationQueryObject
): QueryConfig => {
  const query = `query getSSOOutgoingList($filter: SSOOutgoingFilter, $pagination: PaginationInput) {
            SSOOutgoings(filter: $filter, paginationInput: $pagination) {
                items { id, entity, acsUrl, customer { name }, application { name } },
                pageInfo { pageSize, pageNumber, totalElements, totalPages, hasNext, hasPrevious }
            }
        }`;
  return {
    query: query,
    variables: {
      filter: filter,
      pagination: pagination,
    },
  };
};

export const ssoOutgoingItemQuery = (id: string): QueryConfig => {
  const query = `query getSSOOutgoingItem($id: ID) {
            SSOOutgoing(id: $id) {
                id, entity, acsUrl, ribbonDesc, recipient, destination,
                customer { name, id }, application { id, name }
            }
        }`;
  return {
    query: query,
    variables: {
      id: id,
    },
  };
};

export const createSSOOutgoingMutation = (
  ssoOutgoing: SPMetadata,
  customerId: string | null
): QueryConfig => {
  const query = `mutation createSSOOutgoing($input: SSOOutgoingCreateInput!) {
            createSSOOutgoing(input: $input) {
                id, entity, acsUrl, ribbonDesc, recipient, destination
            }
        }`;
  return {
    query: query,
    variables: {
      input: {
        entity: ssoOutgoing.entity,
        applicationId: ssoOutgoing.application.id,
        customerId: customerId,
        acsUrl: ssoOutgoing.acsUrl,
        ribbonDesc: ssoOutgoing.ribbonDesc,
        recipient: ssoOutgoing.recipient,
        destination: ssoOutgoing.destination,
      },
    },
  };
};

export const updateSSOOutgoingMutation = (
  ssoOutgoing: SPMetadata
): QueryConfig => {
  const query = `mutation updateSSOOutgoing($input: SSOOutgoingUpdateInput!) {
            updateSSOOutgoing(input: $input) {
                id, entity, acsUrl, ribbonDesc, recipient, destination,
                customer { name }, application { id, name }
            }
        }`;
  return {
    query: query,
    variables: {
      input: {
        id: ssoOutgoing.id,
        entity: ssoOutgoing.entity,
        acsUrl: ssoOutgoing.acsUrl,
        ribbonDesc: ssoOutgoing.ribbonDesc,
        recipient: ssoOutgoing.recipient,
        destination: ssoOutgoing.destination,
      },
    },
  };
};

export const deleteSSOOutgoingItemMutation = (id: string): QueryConfig => {
  const query = `mutation deleteSSOOutgoingItem($input: SSOOutgoingDeleteInput!){
            deleteSSOOutgoing(input: $input)
        }`;
  return {
    query: query,
    variables: {
      input: { id: id },
    },
  };
};
